import Vue from "vue";
import App from "./App.vue";
import SocialSharing from 'vue-social-sharing'
import VueYandexMetrika from 'vue-yandex-metrika'
import VueAnalytics from 'vue-analytics'
Vue.use(SocialSharing);

Vue.use(VueYandexMetrika, {
    id: 41254644,
    env: process.env.NODE_ENV
});

Vue.use(VueAnalytics, {
    id: 'UA-88014128-22',
    // debug: {
    //   enabled: true,
    //   trace: false,
    //   sendHitTask: true
    //
    // }
});

Vue.config.productionTip = false;

new Vue({
  render: h => h(App)
}).$mount("#app");
